import { Ident } from '@mode-switch/express';
export var PivotQuery;
(function (PivotQuery) {
    let Type;
    (function (Type) {
        Type["Basic"] = "BASIC";
        Type["Detail"] = "DETAIL";
    })(Type = PivotQuery.Type || (PivotQuery.Type = {}));
    let Basic;
    (function (Basic) {
        function make(pivot) {
            const id = Ident.next();
            const name = pivot.name || id;
            return { ...pivot, id, name, type: "BASIC" };
        }
        Basic.make = make;
    })(Basic = PivotQuery.Basic || (PivotQuery.Basic = {}));
    let Detail;
    (function (Detail) {
        function make(pivot) {
            const id = Ident.next();
            return { ...pivot, id, type: "DETAIL" };
        }
        Detail.make = make;
    })(Detail = PivotQuery.Detail || (PivotQuery.Detail = {}));
    let Marks;
    (function (Marks) {
        function fields(marks) {
            return Object.keys(marks).reduce((fields, channel) => fields.concat(marks[channel] || []), []);
        }
        Marks.fields = fields;
    })(Marks = PivotQuery.Marks || (PivotQuery.Marks = {}));
    let Series;
    (function (Series) {
        function name(series) {
            return series.field.alias;
        }
        Series.name = name;
        function make(field, marks = {}) {
            return { field, marks };
        }
        Series.make = make;
    })(Series = PivotQuery.Series || (PivotQuery.Series = {}));
})(PivotQuery || (PivotQuery = {}));
